module.exports = __webpack_public_path__ + "static/overprinted-15cfbb20c3095af616a203b2efba717c.png";